import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useSiteData } from '../../context/SiteDataContext';

const LOGO_SIZE_CLASSES = {
  1: 'h-16 sm:h-20 md:h-24 lg:h-32',
  2: 'h-24 sm:h-32 md:h-48 lg:h-64',
  3: 'h-32 sm:h-48 md:h-72 lg:h-96',
  4: 'h-40 sm:h-56 md:h-80 lg:h-[28rem]',
};

const HeroSection = () => {
  const { companyInfo, heroImage, logoSize, pageContent } = useSiteData();
  const tagline = pageContent?.heroTagline || 'Reprogrammation moteur, conversion E85 et films solaires à Eugénie les Bains';

  const scrollToContent = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 bg-cover bg-center scale-105" style={{ backgroundImage: `url(${heroImage})` }} />
      <div className="absolute inset-0 bg-black/70" />

      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-4 sm:px-6">
          <img
            src={companyInfo.logo}
            alt={companyInfo.name}
            className={`${LOGO_SIZE_CLASSES[logoSize] || LOGO_SIZE_CLASSES[3]} w-auto mx-auto mb-6 sm:mb-8 drop-shadow-[0_0_60px_rgba(255,255,255,0.25)]`}
          />
          <p className="text-sm sm:text-lg md:text-xl text-white/70 mb-8 sm:mb-10 font-light tracking-wide max-w-2xl mx-auto">
            {tagline}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <Link to="/reprogrammation" data-testid="hero-cta-reprog" className="group inline-flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all duration-300 text-sm sm:text-base">
              <span>Reprogrammation</span>
              <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
            </Link>
            <Link to="/films-solaires" data-testid="hero-cta-films" className="inline-flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium border border-white/20 transition-all duration-300 text-sm sm:text-base">
              <span>Films Solaires</span>
            </Link>
          </div>
        </div>
      </div>

      <button onClick={scrollToContent} className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 text-white/50 hover:text-white transition-colors z-10" data-testid="scroll-indicator">
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs uppercase tracking-[0.3em] font-light">Scroll</span>
          <ChevronDown size={24} className="animate-bounce" />
        </div>
      </button>
    </section>
  );
};

export default HeroSection;
